import React from "react";
import { useTranslation } from "react-i18next";
import "./JobKPICards.css";

interface Application {
  id: number;
  status: string;
  ai_match_score?: number;
}

interface Job {
  created_at?: string;
  status_changed_at?: string;
}

interface JobKPICardsProps {
  job: Job;
  applications: Application[];
}

const JobKPICards: React.FC<JobKPICardsProps> = ({ job, applications }) => {
  const { t } = useTranslation(["recruiting"]);
  const totalApps = applications.length;
  const activeApps = applications.filter(
    (a) => a.status !== "rejected" && a.status !== "archived",
  ).length;

  const matchScores = applications
    .filter((a) => a.ai_match_score != null)
    .map((a) => a.ai_match_score as number);
  const avgMatch =
    matchScores.length > 0
      ? Math.round(matchScores.reduce((s, v) => s + v, 0) / matchScores.length)
      : null;

  const startDate = job.status_changed_at || job.created_at;
  const daysOpen = startDate
    ? Math.floor((Date.now() - new Date(startDate).getTime()) / 86400000)
    : null;

  const kpis = [
    {
      label: t("jobs.detail.kpi.applications"),
      value: String(totalApps),
      color: "#1E40AF",
    },
    {
      label: t("jobs.detail.kpi.active"),
      value: String(activeApps),
      color: "#10B981",
    },
    {
      label: t("jobs.detail.kpi.avgMatch"),
      value: avgMatch === null ? "--" : `${avgMatch}%`,
      color: "#8B5CF6",
    },
    {
      label: t("jobs.detail.kpi.daysOpen"),
      value: daysOpen === null ? "--" : String(daysOpen),
      color: "#F59E0B",
    },
  ];

  return (
    <div className="job-kpi-grid">
      {kpis.map((kpi) => (
        <div key={kpi.label} className="job-kpi-tile">
          <div className="job-kpi-value" style={{ color: kpi.color }}>
            {kpi.value}
          </div>
          <div className="job-kpi-label">{kpi.label}</div>
        </div>
      ))}
    </div>
  );
};

export default JobKPICards;
